import { store } from '@/firebase'
import {
  CollectionName,
  FSAuthorizedService,
  FSChatworkAuthorizedService,
  OauthServiceName
} from '@WombatTechnology/nitte-time-lib'
import {
  collection,
  CollectionReference,
  deleteDoc,
  doc,
  DocumentData,
  getDocs
} from 'firebase/firestore'
import { FormulaUser } from '../formulaUser'
export class AuthorizedService {
  static doc(uid: string, serviceName: OauthServiceName) {
    return doc<FSAuthorizedService, DocumentData>(
      this.collection<FSAuthorizedService>(uid),
      serviceName
    )
  }

  static async delete(uid: string, serviceName: OauthServiceName) {
    return deleteDoc(this.doc(uid, serviceName))
  }

  static chatworkDoc(uid: string) {
    return doc<FSChatworkAuthorizedService, DocumentData>(
      this.collection<FSChatworkAuthorizedService>(uid),
      'chatwork'
    )
  }

  static async authorizedServices(
    uid: string
  ): Promise<FormulaUser['authorizedServices']> {
    const services = await getDocs(this.collection(uid))
    return services.docs.map((s) => s.ref.id as 'zoom') ?? []
  }

  static collection<T>(uid: string) {
    return collection(
      store,
      `${CollectionName.Users}/${uid}/${CollectionName.AuthorizedServices}`
    ) as CollectionReference<T>
  }
}
